import { render, staticRenderFns } from "./TableThresholdEdit.vue?vue&type=template&id=5bb6c20d&scoped=true"
import script from "./TableThresholdEdit.vue?vue&type=script&lang=js"
export * from "./TableThresholdEdit.vue?vue&type=script&lang=js"
import style0 from "./TableThresholdEdit.vue?vue&type=style&index=0&id=5bb6c20d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6c20d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bb6c20d')) {
      api.createRecord('5bb6c20d', component.options)
    } else {
      api.reload('5bb6c20d', component.options)
    }
    module.hot.accept("./TableThresholdEdit.vue?vue&type=template&id=5bb6c20d&scoped=true", function () {
      api.rerender('5bb6c20d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/senior/dialog/TableThresholdEdit.vue"
export default component.exports